import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useRef, useCallback } from "react";
import { eventBus } from "../utils/eventBus";
import { EVENTS } from "../utils/eventTypes";
import {
  setAuth0TokenGetter,
  setUserValidated,
} from "../services/interceptors";

const AuthTokenBridge = () => {
  const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();

  const hasValidated = useRef(false);

  const validateUser = useCallback(async () => {
    try {
      const response = await new Promise((resolve, reject) => {
        const success = (data) => {
          resolve(data);
          cleanup();
        };

        const error = (err) => {
          reject(err);
          cleanup();
        };

        const cleanup = () => {
          eventBus.off(EVENTS.FETCH_VALIDATE_USER_SUCCESS, success);
          eventBus.off(EVENTS.FETCH_API_ERROR, error);
        };
        eventBus.on(EVENTS.FETCH_VALIDATE_USER_SUCCESS, success);
        eventBus.on(EVENTS.FETCH_API_ERROR, error);

        // ✅ allow this API
        eventBus.emit(EVENTS.FETCH_VALIDATE_USER, {
          skipAuthValidation: true,
        });
      });

      if (response && response.code === 90000) {
        setUserValidated(true);
      } else {
        console.log(
          "Validation failed or invalid response - setting flag to FALSE",
        );
        setUserValidated(false);
      }
    } catch (error) {
      console.error("Validation error:", error);
      setUserValidated(false);
    }
  }, []);

  useEffect(() => {
    if (!isLoading && isAuthenticated && !hasValidated.current) {
      hasValidated.current = true;

      setAuth0TokenGetter(getAccessTokenSilently);
      validateUser();
    }
  }, [isLoading, isAuthenticated, getAccessTokenSilently, validateUser]);

  return null;
};
export default AuthTokenBridge;
